import { connect } from 'react-redux'
import { docksideOpenSelector } from 'Modules/app/selectors'
import ListingCountFloatingBar from './ListingCountFloatingBar'

const mapStateToProps = (state) => ({
  dockIsOpen: docksideOpenSelector(state),
  isIE: state.app.isIE,
  haveComparedListings: state.compare.comparedListingsLength > 0,
  algoliaFeaturedTotal: state.listings.searchAlgoliaFeaturedTotal,
  algoliaBuildingPagination: state.algoliaBuildingList.pagination,
})
export default connect(mapStateToProps)(ListingCountFloatingBar)
